import React, { useEffect, useState, useContext, useRef } from "react";
import { getAllFolder, deleteFolder } from "../api/folderapi";
import { useNavigate } from "react-router-dom";
import { BsDownload } from "react-icons/bs";
import { CiMenuKebab } from "react-icons/ci";
import { AiOutlineDelete } from "react-icons/ai";
import { AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";
import { FileContext } from "../context/FileContext";
import FileView from "../Component/FIleView";
import DeleteView from "../Component/DeleteView";
import { CiSearch } from "react-icons/ci";

const Videos = () => {
  const { files, setFiles } = useContext(FileContext);
  const [videos, setVideos] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedFolderForDelete, setSelectedFolderForDelete] = useState(null);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const menuRef = useRef(null);

  useEffect(() => {
    setIsLoading(true);
    getAllFolder()
      .then((res) => {
        const videoFiles = res.data.filter(
          (item) =>
            item.mimeType && item.mimeType.toLowerCase().includes("video")
        );
        setVideos(videoFiles);
      })
      .catch((err) => console.error("Error fetching videos:", err))
      .finally(() => setIsLoading(false));
  }, []);

  const handleItemClick = (item) => {
    if (item.type === "folder") {
      navigate("/folder/" + item._id);
    } else {
      setSelectedFile(item);
    }
  };

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDeleteClick = (file) => {
    setSelectedFolderForDelete(file);
    setIsPopupOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      if (selectedFolderForDelete) {
        await deleteFolder(selectedFolderForDelete._id);

        const updatedFiles = files.filter(
          (file) => file._id !== selectedFolderForDelete._id
        );
        setFiles(updatedFiles);

        const updatedVideos = videos.filter(
          (file) => file._id !== selectedFolderForDelete._id
        );
        setVideos(updatedVideos);

        setIsPopupOpen(false);
        setSelectedFolderForDelete(null);
        toast.success("Deleted successfully!");
      }
    } catch (error) {
      toast.error("Error deleting file");
    }
  };

  const handleDeleteCancel = () => {
    setIsPopupOpen(false);
    setSelectedFolderForDelete(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredVideos = videos.filter((file) =>
    file.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className=" mt-[10%] md:mt-[4%]">
     

      <div className="" />
      <h2 className="mb-4 text-xl font-semibold text-black ">Videos</h2>

      {isLoading ? (
        <div className="flex justify-center items-center min-h-[60vh] min-w-[700px]">
          <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
          {filteredVideos.map((file, index) => (
            <div
              key={index}
              className="relative flex flex-col items-center border border-gray-300 rounded-md shadow w-30 h-30 md:w-44 md:h-40 mt-5"
            >
              {/* Menu icon */}
              <span className="absolute right-0 p-2">
                <CiMenuKebab
                  onClick={() => setMenuOpen(menuOpen === index ? null : index)}
                />
              </span>

              {/* Dropdown menu */}
              <AnimatePresence>
                {menuOpen === index && (
                  <div
                    className="absolute right-0 z-50 w-32 bg-white border border-gray-200 rounded-md shadow-lg top-6 md:w-40"
                    ref={menuRef}
                  >
                    <ul className="flex flex-col p-2">
                      <li>
                        <button
                          onClick={() => handleDownload(file.url)}
                          className="flex items-center w-full gap-2 px-3 py-2 text-gray-700 rounded-md hover:bg-gray-100"
                        >
                          <BsDownload className="w-4 h-4 text-blue-500" />
                          <span className="text-sm font-medium">Download</span>
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => handleDeleteClick(file)}
                          className="flex items-center w-full gap-2 px-3 py-2 text-red-600 rounded-md hover:bg-red-100"
                        >
                          <AiOutlineDelete className="w-4 h-4 text-red-500" />
                          <span className="text-sm font-medium">Delete</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </AnimatePresence>

              {/* Video preview */}
              <video
                onClick={() => {
                  if (file.isLocked && file.privacy === "private") {
                    const enteredPassword = prompt("Enter password to unlock:");
                    if (enteredPassword === file.password) {
                      handleItemClick(file);
                    } else {
                      alert("Incorrect password!");
                    }
                  } else {
                    handleItemClick(file);
                  }
                }}
                src={file.url}
                controls
                className={`object-cover w-full h-48 rounded ${
                  file.isLocked ? "blur-md opacity-50 cursor-not-allowed" : ""
                }`}
              >
                Your browser does not support the video tag.
              </video>

              <div className="mt-2 text-sm font-medium text-center text-gray-700">
                {file.name.slice(0, 10)}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Delete Confirmation Popup */}
      {isPopupOpen && (
        <DeleteView
          handleDeleteCancel={handleDeleteCancel}
          handleDeleteConfirm={handleDeleteConfirm}
        />
      )}

      {/* File Preview Modal */}
      {selectedFile && (
        <FileView
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          handleDownload={handleDownload}
        />
      )}
    </div>
  );
};

export default Videos;
